import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";

const smallFont = {fontSize: 15};

const BrokerageSelect = ({brokerage, setBrokerage, dataSource}) => {
    let brokerages = [];
    if (dataSource === "SIMULATED") {
        brokerages = [{value: "BACKTEST", label: "SIMULATED"}];
    } else {
        brokerages = [{value: "TRADIER", label: "LIVE"}, {value: "BACKTEST", label: "SIMULATED"}];
    }
    return (
        <RadioGroup
            row
            aria-label="brokerage"
            name="brokerage"
            value={brokerage}
            onChange={(ev) => {
                setBrokerage(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={4}>
                    <FormLabel><Typography style={smallFont}>Execution:</Typography></FormLabel>
                </Grid>
                {brokerages.map(b => <Grid item xs={4} key={b.value}>
                    <FormControlLabel key={b.value} value={b.value} control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>{b.label}</Typography>}/>
                </Grid>)}
            </Grid>
        </RadioGroup>
    );
}

export default BrokerageSelect;
